import axios from '../../../axios';

const url = '/api/';

export const getMessageAndInteractionPipeline = () =>
  axios.get(
    url + 'candidate-interaction-messaging-pipelines/candidate-interaction-result-pipelines'
  );
